import { render, staticRenderFns } from "./UcCompanySelector.yaml?vue&type=template&id=d4916140&component"
import script from "./UcCompanySelector.yaml?vue&type=script&lang=ts&component"
export * from "./UcCompanySelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports